import React, { useEffect } from "react";
import { DepartmentForm } from "./Forms/DepartmentForm";
import { PageHeader } from "../../CommonElements/PageTitle";
import { Stack } from "react-bootstrap";
import { Container, Form, Spinner } from "reactstrap";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import {
  useGetOneDepartmentQuery,
  useUpdateDepartmentMutation,
} from "../../services/basicData/basicData";
import { useParams } from "react-router";
import { FormSkeleton } from "./FormFieldSkeletons";

export const EditDepartment = () => {
  const { t } = useTranslation();
  const { id } = useParams();

  const {
    data: departmentResponse,
    isLoading,
    isFetching,
  } = useGetOneDepartmentQuery({ id });
  const department = departmentResponse?.data?.data;
  const loading = isLoading || isFetching;

  const {
    control,
    handleSubmit,
    formState: { errors },
    setError,
    reset,
  } = useForm();
  const { mutate: updateDepartment, isPending } =
    useUpdateDepartmentMutation(setError);

  const onSubmit = (data) => {
    updateDepartment({ ...data, id });
  };

  useEffect(() => {
    if (department) {
      reset(department);
    }
  }, [department, reset]);

  return (
    <Stack gap={2}>
      <PageHeader title={t("EDIT_DEPARTMENT")} />
      <Container fluid>
        <Form onSubmit={handleSubmit(onSubmit)}>
          {loading ? (
            <FormSkeleton />
          ) : (
            <>
              <DepartmentForm control={control} errors={errors} />
              <Button variant="primary" type="submit" disabled={isPending}>
                {isPending ? (
                  <>
                    <Spinner size="sm" />
                    {t("UPDATING_DEPARTMENT")}
                  </>
                ) : (
                  t("UPDATE_DEPARTMENT")
                )}
              </Button>
            </>
          )}
        </Form>
      </Container>
    </Stack>
  );
};
